import { Container } from '@mui/material';
import checkIcon from 'assets/icons/check.svg';
import { setCancelationModalOpen } from 'v3/data/store/cancellationNavigation/actions';
import { AlignIcon, Content, Icon, TitleSection } from 'v3/pages/OnlineContracting/Cancellation/styles';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';

export const RefusedCancellationStep = () => {
  const handleConfirm = () => {
    setCancelationModalOpen(false);
  };
  return (
    <Content>
      <AlignIcon>
        <Icon src={checkIcon} alt="Success" />
      </AlignIcon>
      <TitleSection>
        <HeadlineSmall>A solicitação de cancelamento foi recusada!</HeadlineSmall>
      </TitleSection>
      <Container>
        <FlexButton text="Ok, entendi" size="small" handleClick={handleConfirm} />
      </Container>
    </Content>
  );
};
